import React, { useRef, useState } from 'react';
import { TextField, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import AgGridTable from 'components/Preview/preview-table/AgGridTable.component';
import oneTwoThree from 'assets/svgs/oneTwoThree.svg';
import dateIcon from 'assets/svgs/date.svg';
import abc from 'assets/svgs/abc.svg';
import NothingFound from './Components/NothingFound';
import { colors } from 'theme/color-palette';

const TypeRenderer = (params) => {
	if (params.data?.dataType === 'number') {
		return <img src={oneTwoThree} alt="custom-dataset-number-icon" />;
	}
	if (params.data?.dataType === 'date') {
		return <img src={dateIcon} alt="custom-dataset-date-icon" />;
	}
	return <img src={abc} alt="custom-dataset-abc-icon" />;
};

const getCellStyle = (params) => {
	if (params.data.isDisabled) {
		return { color: colors.DISABLED };
	}
	return null;
};

const columnDefs = [
	{
		headerName: '',
		field: 'dataType',
		maxWidth: 60,
		cellRenderer: TypeRenderer,
		cellStyle: (params) => getCellStyle(params)
	},
	{
		headerName: 'Data Name',
		field: 'businessName',
		maxWidth: 250,
		tooltipField: 'businessName',
		cellStyle: (params) => getCellStyle(params)
	},
	{
		headerName: 'DSS Alias',
		field: 'dssName',
		maxWidth: 200,
		tooltipField: 'dssName',
		cellStyle: (params) => getCellStyle(params)
	},
	{
		headerName: 'Type',
		field: 'type',
		maxWidth: 120,
		cellStyle: (params) => getCellStyle(params)
	},
	{
		headerName: 'Description',
		field: 'description',
		maxWidth: 280,
		tooltipField: 'description',
		cellStyle: (params) => getCellStyle(params)
	}
];

export const TableView = ({ tablesInfo }) => {
	const gridApi = useRef();
	const [isFound, setIsFound] = useState(true);
	const onGridReady = (event) => {
		gridApi.current = event.api;
	};
	const [searchText, setSearchText] = useState('');

	const handleSearchChange = (e) => {
		const newSearchText = e.currentTarget.value;
		setSearchText(newSearchText);
		const findDataName = (obj) =>
			obj.businessName.toLowerCase().includes(e.currentTarget.value.toLowerCase());
		const found = tablesInfo.some(findDataName);
		setIsFound(found);
		gridApi.current.setQuickFilter(e.currentTarget.value);
	};

	return (
		<div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
			<div style={{ margin: '5px 0', width: '288px' }}>
				<TextField
					fullWidth
					id="outlined-basic"
					placeholder="Search data"
					variant="outlined"
					size="small"
					onChange={(e) => {
						handleSearchChange(e);
					}}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<SearchIcon />
							</InputAdornment>
						)
					}}
				/>
			</div>
			{isFound ? (
				<div className="custom-dataset-table-view" style={{ marginTop: '15px', flex: 1 }}>
					<AgGridTable
						data={tablesInfo}
						columnDefs={columnDefs}
						tooltipShowDelay={500}
						tooltipInteraction={true}
						style={{ height: '100%' }}
						onReadyFn={onGridReady}
					/>
				</div>
			) : (
				<div
					style={{
						width: '100%',
						display: 'flex',
						alignItems: 'flex-start',
						justifyContent: 'center'
					}}>
					<NothingFound searchKeyword={searchText} type="full-width" />
				</div>
			)}
		</div>
	);
};
